
<template>
  <div>
    <v-app-bar app color="#ededed" dark elevation="0" class="linear">
      <v-app-bar-nav-icon color="#fff" @click.stop="sidebarMenu = !sidebarMenu"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-menu bottom left top offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="#fff">fa-ellipsis-v</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(menu, i) in menus"
            :key="i"
            @click="menu.action($router)"
          >
            <v-list-item-title>{{ menu.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="sidebarMenu"
      v-click-outside="{
        handler: onClickOutsideWithConditional,
        closeConditional,
      }"
      app
      floating
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
      color="#0079be"
    >
      <!-- <v-list-item class="px-2" @click="toggleMini = !toggleMini">
        <v-list-item-avatar>
          <v-icon color="white">mdi-account-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="text-truncate white--text">
          Username
        </v-list-item-content>
      </v-list-item> -->
      <v-divider></v-divider>
      <v-list>
        <v-list-item @click="sidebarMenu = !sidebarMenu" class="white--text" v-for="route in verifiedRoles" :key="route.id" link :to="route.path">
          <v-list-item-icon>
            <!-- <v-icon color="primary">{{ item.icon }}</v-icon> -->
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text text--uppercase">{{ route.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item @click="sidebarMenu = !sidebarMenu" class="white--text" link :to="'/course'">
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text text--uppercase">EXERCÍCIOS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="sidebarMenu = !sidebarMenu" class="white--text" link :to="'/course'">
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text text--uppercase">DESEMPENHO</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
    <v-main class="dashboard">
      <v-container class="px-4 py-0 fill-height dashboard" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      routes: [],
      sidebarMenu: false,
      toggleMini: false,
      mini: false,
      menus: [
        // { name: 'Configurações', action: ($router) => this.goMyData($router) },
        { name: 'Sair', action: ($router) => this.logout($router) }
      ]
    }
  },
  computed: {
    verifiedRoles () {
      return this.routes.filter(route => this.verifyRoles(route.meta.roles))
    }
  },
  mounted () {
    this.routes = this.$router.options.routes
    this.routes = this.routes.filter(route => (route.meta.acess ? route : ''))
  },
  methods: {
    ...mapActions('Login', ['logout']),
    goMyData ($router) {
      $router.push('/my-data')
    },
    verifyRoles (rolesOfRoute) {
      const rolesOfUser = this.recoverRoles()
      return rolesOfUser.some(role =>
        this.verifyIfRoleExistInRolesRoute(rolesOfRoute, role)
      )
    },
    recoverRoles () {
      const data = JSON.parse(localStorage.getItem('data_travessia_webapp'))
      const rolesOfUser = data === null ? ['all'] : data.role
      return rolesOfUser
    },
    verifyIfRoleExistInRolesRoute (rolesRoute, role) {
      for (const route of rolesRoute) {
        if (route.includes(role)) {
          return true
        }
      }
      return false
    },
    onClickOutsideWithConditional () {
      this.sidebarMenu = false
    },
    closeConditional (e) {
      return this.sidebarMenu
    }
  }
}
</script>

<style scoped>
.text--uppercase {
  text-transform: uppercase;
}

.linear {
  background: linear-gradient(180deg, #2049BC 0%, #56CCF2 100%);
}

.dashboard {
  background: #EAEFF0;
}
</style>
